import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { baseLensApi, getVoiceApi } from '../services/config.service';

const AudioPlayer = ({ recordingUrl, rowId }: { recordingUrl: string, rowId: string }) => {
    const [audioSrc, setAudioSrc] = useState<string | null>(null); // Track the audio source
    const [isLoading, setIsLoading] = useState(false); // Track loading state

    useEffect(() => {
        const fetchAudio = async () => {
            try {
                setIsLoading(true); // Show loading indicator
                const url = recordingUrl
                    ? `${baseLensApi()}${recordingUrl}`
                    : `${baseLensApi()}/api/voice/v1/results/${rowId}/content?contentType=audio/wav`;
                const token = localStorage.getItem('TOKEN');
                const response = await fetch(url, {
                    headers: token ? { 'Authorization': `Bearer ${token}` } : {}
                });

                const blob = await response.blob(); // Convert response to Blob
                const objectUrl = URL.createObjectURL(blob); // Create object URL for the Blob
                setAudioSrc(objectUrl); // Set the audio source
            } catch (error) {
                console.error("Error fetching audio:", error);
               // alert("Failed to load audio. Please try again.");
            } finally {
                setIsLoading(false); // Hide loading indicator
            }
        };

        fetchAudio(); // Automatically fetch audio on load
    }, [recordingUrl]); // Dependency ensures the effect runs when recordingUrl changes
    return (
        <div>
            {isLoading && (
                <CircularProgress size={24} style={{ marginBottom: '10px' }} /> // Show loading indicator while fetching
            )}
            {audioSrc && (
                <audio controls>
                    <source src={audioSrc} type="audio/wav" />
                </audio>
            )}
        </div>
    );
};

export default AudioPlayer;